import { render, staticRenderFns } from "./widget_last_ipos.vue?vue&type=template&id=aa251f32&scoped=true&"
import script from "./widget_last_ipos.vue?vue&type=script&lang=js&"
export * from "./widget_last_ipos.vue?vue&type=script&lang=js&"
import style0 from "./widget_last_ipos.vue?vue&type=style&index=0&id=aa251f32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa251f32",
  null
  
)

export default component.exports